// extracted by mini-css-extract-plugin
export default {"SearchMessage":"NoContent_SearchMessage__RzGo4"};